import { FaUsers } from "react-icons/fa";
import LoginSection from "./LoginSection";
import loginBg from "../../../assets-user/login/hero_bg.png";

const HeroBannerAndLogin = () => {
  const agents = [
    { id: 1, color: "bg-blue-500" },
    { id: 2, color: "bg-purple-500" },
    { id: 3, color: "bg-pink-500" },
    { id: 4, color: "bg-orange-500" },
  ];

  return (
    <div className="flex flex-col">
      <div
        style={{ backgroundImage: `url(${loginBg})` }}
        className=" lg:min-h-[89vh] relative bg-cover bg-center flex flex-col md:flex-row items-center w-full px-4 md:px-8 lg:px-10 z-10"
      >
        <div className="absolute inset-0 bg-black/70 z-20"></div>
        <div className="container mx-auto  py-8 lg:py-12 z-30">
          <div className="grid grid-cols-1 lg:grid-cols-10 gap-4 lg:gap-12 items-center">
            {/* Hero Banner Section */}
            <div className="text-white lg:col-span-6 space-y-4 lg:space-y-6">
              <p className="text-sm sm:text-base md:text-lg lg:text-xl  text-gray-200">
                Sell or Rent Your Property Faster
              </p>
              <h1 className="text-[1.65rem] max-w-[80%] md:max-w-full sm:text-3xl lg:text-5xl font-semibold leading-snug sm:leading-relaxed lg:leading-[1.3] tracking-wide">
                Free Property Listings on the Nation's #1 Real Estate Hub
              </h1>

              <div className="flex items-center gap-4 pt-2">
                <button className="bg-btn-brandRed  hover:bg-btn-brandRedHover text-white  px-4 py-3 rounded-l-2xl rounded-tr-2xl transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg">
                  Get Started
                </button>

                <div className="flex items-center gap-3">
                  <div className="flex -space-x-3">
                    {agents.map((agent) => (
                      <div
                        key={agent.id}
                        className={`
                        w-10 h-10 sm:w-12 sm:h-12 rounded-full ${agent.color} border-2 border-gray-800 
                        flex items-center justify-center
                        transition-all duration-300 ease-out
                        hover:scale-110 hover:z-10 
                        group cursor-pointer
                        relative overflow-hidden
                        before:absolute before:inset-0 
                        shadow-md hover:shadow-xl
                        transform-gpu
                      `}
                      >
                        <FaUsers className="text-white text-sm w-full transition-transform duration-300 group-hover:scale-110 z-10 relative" />

                        {/* Pulse animation on hover */}
                        <div className="absolute inset-0 border-2 border-white/30 rounded-full animate-ping opacity-0 group-hover:opacity-100 group-hover:animate-pulse" />
                      </div>
                    ))}
                  </div>

                  <div className="text-left">
                    <p className="text-lg sm:text-xl ">250+</p>
                    <p className="text-xs sm:text-sm text-gray-300">Agents</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Login Form Section */}
            <div className={`lg:col-span-4 hidden lg:block`}>
              <LoginSection />
            </div>
          </div>
        </div>
      </div>
      {/* For Mobile Screens */}
      <div className="pb-20 lg:hidden">
        <LoginSection />
      </div>
    </div>
  );
};

export default HeroBannerAndLogin;
